import React from 'react';
import {
  Heading,
  Copy,
  StackSpace,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import { useScreenSizes } from 'src/utilities/useScreenSizes';

type PageSectionTitleProps = {
  title: string;
  subtitle?: React.ReactNode;
  y?: StackSpace;
  headingVariant?: 'h3' | 'h4' | 'h5';
  subtitleY?: StackSpace;
};

export const PageSectionTitle: React.FC<PageSectionTitleProps> = ({
  title,
  subtitle,
  headingVariant = 'h4',
  y = 'sm',
  subtitleY = 'x-sm',
}) => {
  const { isPhone } = useScreenSizes();

  const deviceX = isPhone ? 'none' : 'md';

  return (
    <Stack y={y} x={deviceX}>
      {subtitle ? (
        <>
          <Stack y={subtitleY}>
            <Heading variant={headingVariant}>{title}</Heading>
          </Stack>
          <Copy variant="body">{subtitle}</Copy>
        </>
      ) : (
        <Heading variant={headingVariant}>{title}</Heading>
      )}
    </Stack>
  );
};
